import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-form"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "step1"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "o-title-1" }, " Étape 1 ", -1 /* HOISTED */)
const _hoisted_5 = { class: "o-grid o-formulaire__item" }
const _hoisted_6 = { class: "o-grid-6" }
const _hoisted_7 = {
  for: "",
  class: "o-label"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("small", null, "Veuillez entrer le ISBN de livre de la séance de décicace.", -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer" }, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "o-button__container" }
const _hoisted_12 = {
  key: 1,
  class: "step2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", { class: "o-title-1" }, " Étape 2 ", -1 /* HOISTED */)
const _hoisted_14 = { class: "o-grid o-formulaire__item" }
const _hoisted_15 = { class: "o-grid-12" }
const _hoisted_16 = {
  for: "",
  class: "o-label"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_18 = { class: "o-select__wrap" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Sélectionnez dans la liste déroulante", -1 /* HOISTED */)
const _hoisted_20 = ["value"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("small", null, "Veuillez choisir l'auteur présent pour la séance de décicace.", -1 /* HOISTED */)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer" }, null, -1 /* HOISTED */)
const _hoisted_23 = { class: "o-button__container" }
const _hoisted_24 = {
  key: 2,
  class: "step3"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h2", { class: "o-title-1" }, " Étape 3 ", -1 /* HOISTED */)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", { class: "o-title-2" }, " Auteur.e ", -1 /* HOISTED */)
const _hoisted_27 = { class: "o-grid o-formulaire__item" }
const _hoisted_28 = { class: "o-grid-6" }
const _hoisted_29 = {
  for: "",
  class: "o-label"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_31 = { class: "o-grid-6" }
const _hoisted_32 = {
  for: "",
  class: "o-label"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer" }, null, -1 /* HOISTED */)
const _hoisted_35 = { class: "o-grid" }
const _hoisted_36 = { class: "o-grid-6" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_38 = ["src"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("small", null, "Fichier de moins de 5mo si possible", -1 /* HOISTED */)
const _hoisted_40 = { class: "o-grid-6" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_42 = ["src"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("small", null, "Fichier de moins de 5mo si possible", -1 /* HOISTED */)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer" }, null, -1 /* HOISTED */)
const _hoisted_45 = { class: "o-grid" }
const _hoisted_46 = { class: "o-grid-12" }
const _hoisted_47 = {
  for: "",
  class: "o-label"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_49 = { class: "o-select__wrap" }
const _hoisted_50 = /*#__PURE__*/_createStaticVNode("<option value=\"\" disabled selected>Sélectionnez dans la liste déroulante</option><option value=\"Auteur\">Auteur</option><option value=\"Auteure\">Auteure</option><option value=\"Autrice\">Autrice</option><option value=\"Illustrateur\">Illustrateur</option><option value=\"Illustratrice\">Illustratrice</option>", 6)
const _hoisted_56 = [
  _hoisted_50
]
const _hoisted_57 = { class: "o-grid-12" }
const _hoisted_58 = {
  for: "",
  class: "o-label"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_60 = { class: "o-grid-4" }
const _hoisted_61 = {
  for: "",
  class: "o-label"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_63 = { class: "o-grid-4" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "o-label" }, " Logo de la maison d'édition ", -1 /* HOISTED */)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_66 = ["src"]
const _hoisted_67 = { class: "o-grid-4" }
const _hoisted_68 = {
  for: "",
  class: "o-label"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_70 = { class: "o-select__wrap" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Sélectionnez dans la liste déroulante", -1 /* HOISTED */)
const _hoisted_72 = ["value"]
const _hoisted_73 = { class: "o-grid-12" }
const _hoisted_74 = {
  for: "",
  class: "o-label"
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("small", { style: {"color":"red"} }, "(Pour la page de présentation de la maison d'édition sur notre site internet. Remplir une seule fois.)", -1 /* HOISTED */)
const _hoisted_77 = { class: "o-grid-6" }
const _hoisted_78 = {
  for: "",
  class: "o-label"
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_80 = { class: "o-grid-6" }
const _hoisted_81 = {
  for: "",
  class: "o-label"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_83 = { class: "o-grid-6" }
const _hoisted_84 = {
  for: "",
  class: "o-label"
}
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_87 = { class: "o-select__wrap" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Sélectionnez dans la liste déroulante", -1 /* HOISTED */)
const _hoisted_89 = ["value"]
const _hoisted_90 = { class: "o-grid-6" }
const _hoisted_91 = {
  for: "",
  class: "o-label"
}
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_94 = { class: "o-select__wrap" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Sélectionnez dans la liste déroulante", -1 /* HOISTED */)
const _hoisted_96 = ["value"]
const _hoisted_97 = { class: "o-grid-12" }
const _hoisted_98 = {
  for: "",
  class: "o-label"
}
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer" }, null, -1 /* HOISTED */)
const _hoisted_101 = { class: "o-grid" }
const _hoisted_102 = { class: "o-grid-12" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "o-label" }, " L’auteur.e est-il (elle) originaire ou habite-t-il (elle) la Mauricie ou le Centre-du-Québec? ", -1 /* HOISTED */)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_105 = { class: "o-button__container" }
const _hoisted_106 = { class: "o-checkbox__wrap" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("label", {
  for: "checkbox-mauricie",
  class: "o-checkbox-label"
}, " Mauricie ", -1 /* HOISTED */)
const _hoisted_108 = { class: "o-checkbox__wrap" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", {
  for: "checkbox-quebec",
  class: "o-checkbox-label"
}, " Centre-du-Québec ", -1 /* HOISTED */)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer" }, null, -1 /* HOISTED */)
const _hoisted_111 = { class: "o-grid" }
const _hoisted_112 = { class: "o-grid-12" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "o-label" }, " Cochez s'il s'agit d'un.e : ", -1 /* HOISTED */)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_115 = { class: "o-button__container" }
const _hoisted_116 = { class: "o-checkbox__wrap" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("label", {
  for: "checkbox-jeunesse",
  class: "o-checkbox-label"
}, " Auteur.e jeunesse ", -1 /* HOISTED */)
const _hoisted_118 = { class: "o-checkbox__wrap" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("label", {
  for: "checkbox-illustration",
  class: "o-checkbox-label"
}, " Illustrateur.rice ", -1 /* HOISTED */)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer" }, null, -1 /* HOISTED */)
const _hoisted_121 = { class: "" }
const _hoisted_122 = { class: "o-table o-table-seances" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_124 = { class: "u-hide-over-sm o-label" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_126 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_127 = { class: "o-table-formulaire__spanmobile" }
const _hoisted_128 = ["onUpdate:modelValue"]
const _hoisted_129 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1 /* HOISTED */)
const _hoisted_130 = ["value"]
const _hoisted_131 = ["onUpdate:modelValue"]
const _hoisted_132 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1 /* HOISTED */)
const _hoisted_133 = ["value"]
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer" }, null, -1 /* HOISTED */)
const _hoisted_135 = { class: "o-button__container" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#cancel" })
], -1 /* HOISTED */)
const _hoisted_137 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#save" })
], -1 /* HOISTED */)
const _hoisted_138 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_139 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer" }, null, -1 /* HOISTED */)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("h3", { class: "o-title-3 -text-no-margin" }, " Liste de vos séances de dédicaces ", -1 /* HOISTED */)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-sm" }, null, -1 /* HOISTED */)
const _hoisted_142 = { class: "" }
const _hoisted_143 = { class: "o-table o-table-seances" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "thead" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "o-table-th-form" }, "Nom"),
    /*#__PURE__*/_createElementVNode("th", { class: "o-table-th-form" }, "Prénom"),
    /*#__PURE__*/_createElementVNode("th", { class: "o-table-th-form" }, "Livre"),
    /*#__PURE__*/_createElementVNode("th", { class: "o-table-th-form" }, "Maison d'édition"),
    /*#__PURE__*/_createElementVNode("th", { class: "o-table-th-form" })
  ])
], -1 /* HOISTED */)
const _hoisted_145 = { class: "o-table-td-form" }
const _hoisted_146 = {
  "data-label": "Nom",
  class: "o-table-td-form__item"
}
const _hoisted_147 = { class: "o-table-td-form" }
const _hoisted_148 = {
  "data-label": "Prénom",
  class: "o-table-td-form__item"
}
const _hoisted_149 = { class: "o-table-td-form" }
const _hoisted_150 = {
  "data-label": "Livre",
  class: "o-table-td-form__item"
}
const _hoisted_151 = { class: "o-table-td-form" }
const _hoisted_152 = {
  "data-label": "Maison d'édition",
  class: "o-table-td-form__item"
}
const _hoisted_153 = { class: "o-table-td-form" }
const _hoisted_154 = { class: "o-button__container" }
const _hoisted_155 = ["onClick"]
const _hoisted_156 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#edit" })
], -1 /* HOISTED */)
const _hoisted_157 = ["onClick"]
const _hoisted_158 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#trash" })
], -1 /* HOISTED */)
const _hoisted_159 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer" }, null, -1 /* HOISTED */)
const _hoisted_160 = { class: "o-button__container" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#add" })
], -1 /* HOISTED */)
const _hoisted_162 = /*#__PURE__*/_createElementVNode("a", {
  href: "/wp/wp-login.php?action=logout",
  class: "o-btn o-table-btn"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    focusable: "false",
    class: "o-ico"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#logout" })
  ]),
  /*#__PURE__*/_createTextVNode(" Déconnexion ")
], -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($data.edit!=false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          ($data.step==1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("label", _hoisted_7, [
                      _createTextVNode(" ISBN du livre "),
                      _hoisted_8,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.edit.livre.isbn) = $event)),
                        class: "o-input",
                        required: ""
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $data.edit.livre.isbn]
                      ])
                    ]),
                    _hoisted_9
                  ])
                ]),
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = $event => ($options.searchISBN())),
                    class: "o-btn o-table-btn"
                  }, " Suivant ")
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($data.step==2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, [
                      _createTextVNode(" Choisir un des auteurs "),
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.selectedContributor) = $event)),
                          class: "o-select"
                        }, [
                          _hoisted_19,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.contributors, (contributor) => {
                            return (_openBlock(), _createElementBlock("option", { value: contributor }, _toDisplayString(contributor.person.name), 9 /* TEXT, PROPS */, _hoisted_20))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */), [
                          [_vModelSelect, $data.selectedContributor]
                        ])
                      ])
                    ]),
                    _hoisted_21
                  ])
                ]),
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = $event => ($options.fillContributor())),
                    class: "o-btn o-table-btn"
                  }, " Suivant ")
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($data.step==3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _hoisted_25,
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("label", _hoisted_29, [
                      _createTextVNode(" Prénom "),
                      _hoisted_30,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.edit.auteur.firstname) = $event)),
                        onKeyup: _cache[5] || (_cache[5] = (...args) => ($options.searchAuteur && $options.searchAuteur(...args))),
                        class: "o-input"
                      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                        [_vModelText, $data.edit.auteur.firstname]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("label", _hoisted_32, [
                      _createTextVNode(" Nom "),
                      _hoisted_33,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.edit.auteur.lastname) = $event)),
                        onKeyup: _cache[7] || (_cache[7] = (...args) => ($options.searchAuteur && $options.searchAuteur(...args))),
                        class: "o-input"
                      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                        [_vModelText, $data.edit.auteur.lastname]
                      ])
                    ])
                  ])
                ]),
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createTextVNode(" Photo de l'auteur.e "),
                    _hoisted_37,
                    ($data.edit.auteur.photo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: $data.edit.auteur.photo.url,
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_38))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("input", {
                      type: "file",
                      onChange: _cache[8] || (_cache[8] = (...args) => ($options.onFileChanged && $options.onFileChanged(...args))),
                      "data-type": "photo"
                    }, null, 32 /* NEED_HYDRATION */),
                    _hoisted_39
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createTextVNode(" Couverture du Livre "),
                    _hoisted_41,
                    ($data.edit.livre.couverture)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: $data.edit.livre.couverture.url,
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_42))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("input", {
                      type: "file",
                      onChange: _cache[9] || (_cache[9] = (...args) => ($options.onFileChanged && $options.onFileChanged(...args))),
                      "data-type": "cover"
                    }, null, 32 /* NEED_HYDRATION */),
                    _hoisted_43
                  ])
                ]),
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("label", _hoisted_47, [
                      _createTextVNode(" Titre (pour l’accréditation) "),
                      _hoisted_48,
                      _createElementVNode("div", _hoisted_49, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($data.edit.auteur.titre) = $event)),
                          class: "o-select"
                        }, _hoisted_56, 512 /* NEED_PATCH */), [
                          [_vModelSelect, $data.edit.auteur.titre]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("label", _hoisted_58, [
                      _createTextVNode(" Courte notice biographique "),
                      _hoisted_59,
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($data.edit.auteur.bio) = $event)),
                        class: "o-input"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $data.edit.auteur.bio]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("label", _hoisted_61, [
                      _createTextVNode(" Maison d'édition "),
                      _hoisted_62,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($data.edit.livre.maison.title) = $event)),
                        onKeyup: _cache[13] || (_cache[13] = (...args) => ($options.searchMaison && $options.searchMaison(...args))),
                        class: "o-input"
                      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                        [_vModelText, $data.edit.livre.maison.title]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _hoisted_64,
                    _hoisted_65,
                    ($data.edit.livre.maison.thumbnail)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: $data.edit.livre.maison.thumbnail.url,
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_66))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("input", {
                      type: "file",
                      onChange: _cache[14] || (_cache[14] = (...args) => ($options.onFileChanged && $options.onFileChanged(...args))),
                      "data-type": "logo"
                    }, null, 32 /* NEED_HYDRATION */)
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("label", _hoisted_68, [
                      _createTextVNode(" Numéro de stand "),
                      _hoisted_69,
                      _createElementVNode("div", _hoisted_70, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => (($data.edit.stand_id) = $event)),
                          class: "o-select"
                        }, [
                          _hoisted_71,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.stands, (stand, i) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: stand.id
                            }, _toDisplayString(stand.no), 9 /* TEXT, PROPS */, _hoisted_72))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */), [
                          [_vModelSelect, $data.edit.stand_id]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("label", _hoisted_74, [
                      _createTextVNode(" Description de la maison d'édition "),
                      _hoisted_75,
                      _withDirectives(_createElementVNode("textarea", {
                        class: "o-input",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (($data.edit.livre.maison.desc) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $data.edit.livre.maison.desc]
                      ])
                    ]),
                    _hoisted_76
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("label", _hoisted_78, [
                      _createTextVNode(" Titre du livre "),
                      _hoisted_79,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => (($data.edit.livre.title) = $event)),
                        onKeyup: _cache[18] || (_cache[18] = (...args) => ($options.searchLivre && $options.searchLivre(...args))),
                        class: "o-input"
                      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                        [_vModelText, $data.edit.livre.title]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("label", _hoisted_81, [
                      _createTextVNode(" ISBN du livre "),
                      _hoisted_82,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => (($data.edit.livre.isbn) = $event)),
                        class: "o-input",
                        required: ""
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $data.edit.livre.isbn]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("label", _hoisted_84, [
                      _createTextVNode(" Genre littéraire #1 "),
                      _hoisted_85,
                      _hoisted_86,
                      _createCommentVNode(" <input type=\"text\" v-model=\"edit.genre\" class=\"o-input\"> "),
                      _createElementVNode("div", _hoisted_87, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => (($data.edit.livre.genre) = $event)),
                          class: "o-select"
                        }, [
                          _hoisted_88,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.genres, (genre, i) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: genre.term_id
                            }, _toDisplayString(genre.name), 9 /* TEXT, PROPS */, _hoisted_89))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */), [
                          [_vModelSelect, $data.edit.livre.genre]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("label", _hoisted_91, [
                      _createTextVNode(" Genre littéraire #2 "),
                      _hoisted_92,
                      _hoisted_93,
                      _createCommentVNode(" <input type=\"text\" v-model=\"edit.genre\" class=\"o-input\"> "),
                      _createElementVNode("div", _hoisted_94, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => (($data.edit.livre.genre2) = $event)),
                          class: "o-select"
                        }, [
                          _hoisted_95,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.genres, (genre, i) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: genre.term_id
                            }, _toDisplayString(genre.name), 9 /* TEXT, PROPS */, _hoisted_96))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */), [
                          [_vModelSelect, $data.edit.livre.genre2]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_97, [
                    _createElementVNode("label", _hoisted_98, [
                      _createTextVNode(" Blogue ou site web de l'auteur (sans http://) "),
                      _hoisted_99,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => (($data.edit.auteur.web) = $event)),
                        class: "o-input"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $data.edit.auteur.web]
                      ])
                    ])
                  ])
                ]),
                _hoisted_100,
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("div", _hoisted_102, [
                    _hoisted_103,
                    _hoisted_104,
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("div", _hoisted_106, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => (($data.edit.auteur.originaire) = $event)),
                          value: "Mauricie",
                          class: "o-checkbox",
                          id: "checkbox-mauricie",
                          onfocus: "this.blur()"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelCheckbox, $data.edit.auteur.originaire]
                        ]),
                        _hoisted_107
                      ]),
                      _createElementVNode("div", _hoisted_108, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => (($data.edit.auteur.originaire) = $event)),
                          value: "Centre-du-Québec",
                          class: "o-checkbox",
                          id: "checkbox-quebec",
                          onfocus: "this.blur()"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelCheckbox, $data.edit.auteur.originaire]
                        ]),
                        _hoisted_109
                      ])
                    ])
                  ])
                ]),
                _hoisted_110,
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("div", _hoisted_112, [
                    _hoisted_113,
                    _hoisted_114,
                    _createElementVNode("div", _hoisted_115, [
                      _createElementVNode("div", _hoisted_116, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => (($data.edit.auteur.jeunesse) = $event)),
                          class: "o-checkbox",
                          id: "checkbox-jeunesse",
                          value: "1",
                          onfocus: "this.blur()"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelCheckbox, $data.edit.auteur.jeunesse]
                        ]),
                        _hoisted_117
                      ]),
                      _createElementVNode("div", _hoisted_118, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => (($data.edit.auteur.illustration) = $event)),
                          class: "o-checkbox",
                          id: "checkbox-illustration",
                          value: "1",
                          onfocus: "this.blur()"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelCheckbox, $data.edit.auteur.illustration]
                        ]),
                        _hoisted_119
                      ])
                    ])
                  ])
                ]),
                _hoisted_120,
                _createElementVNode("div", _hoisted_121, [
                  _createElementVNode("table", _hoisted_122, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dates, (date, i) => {
                          return (_openBlock(), _createElementBlock("th", null, [
                            _createElementVNode("span", null, _toDisplayString(date.name), 1 /* TEXT */),
                            _hoisted_123,
                            _createTextVNode(_toDisplayString(date.label), 1 /* TEXT */)
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      ($data.edit.seances)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList([0,1,2], (i) => {
                            return _createElementVNode("tr", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dates, (date, di) => {
                                return (_openBlock(), _createElementBlock("td", null, [
                                  _createElementVNode("span", _hoisted_124, [
                                    _createTextVNode(_toDisplayString(date.name), 1 /* TEXT */),
                                    _hoisted_125,
                                    _createTextVNode(_toDisplayString(date.label) + " ", 1 /* TEXT */),
                                    _hoisted_126
                                  ]),
                                  _createElementVNode("span", _hoisted_127, [
                                    _createCommentVNode(" <span class=\"o-table-formulaire__headmobile\">{{ date.label }}</span> "),
                                    _withDirectives(_createElementVNode("select", {
                                      style: {},
                                      "onUpdate:modelValue": $event => (($data.edit.seances[date.date][i][0]) = $event)
                                    }, [
                                      _hoisted_129,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.dateHoursFirst(di), (hour) => {
                                        return (_openBlock(), _createElementBlock("option", { value: hour }, _toDisplayString(hour), 9 /* TEXT, PROPS */, _hoisted_130))
                                      }), 256 /* UNKEYED_FRAGMENT */))
                                    ], 8 /* PROPS */, _hoisted_128), [
                                      [_vModelSelect, $data.edit.seances[date.date][i][0]]
                                    ]),
                                    _createTextVNode("  à  "),
                                    _withDirectives(_createElementVNode("select", {
                                      style: {},
                                      "onUpdate:modelValue": $event => (($data.edit.seances[date.date][i][1]) = $event)
                                    }, [
                                      _hoisted_132,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.dateHoursLast(di), (hour) => {
                                        return (_openBlock(), _createElementBlock("option", { value: hour }, _toDisplayString(hour), 9 /* TEXT, PROPS */, _hoisted_133))
                                      }), 256 /* UNKEYED_FRAGMENT */))
                                    ], 8 /* PROPS */, _hoisted_131), [
                                      [_vModelSelect, $data.edit.seances[date.date][i][1]]
                                    ])
                                  ])
                                ]))
                              }), 256 /* UNKEYED_FRAGMENT */))
                            ])
                          }), 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ]),
                _hoisted_134,
                _createElementVNode("div", _hoisted_135, [
                  _createElementVNode("button", {
                    onClick: _cache[27] || (_cache[27] = (...args) => ($options.cancel && $options.cancel(...args))),
                    class: "o-btn o-table-btn"
                  }, [
                    _hoisted_136,
                    _createTextVNode(" Annuler ")
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[28] || (_cache[28] = $event => ($options.save($data.edit))),
                    class: "o-btn o-table-btn"
                  }, [
                    _hoisted_137,
                    _createTextVNode(" Sauvegarder ")
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" end step3 "),
          _hoisted_138
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", null, [
      _hoisted_139,
      _hoisted_140,
      _hoisted_141,
      _createElementVNode("div", _hoisted_142, [
        _createElementVNode("table", _hoisted_143, [
          _hoisted_144,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.auteurs, (d, id) => {
              return (_openBlock(), _createElementBlock("tr", { key: id }, [
                _createElementVNode("td", _hoisted_145, [
                  _createElementVNode("span", _hoisted_146, _toDisplayString(d.auteur.lastname), 1 /* TEXT */)
                ]),
                _createElementVNode("td", _hoisted_147, [
                  _createElementVNode("span", _hoisted_148, _toDisplayString(d.auteur.firstname), 1 /* TEXT */)
                ]),
                _createElementVNode("td", _hoisted_149, [
                  _createElementVNode("span", _hoisted_150, _toDisplayString(d.livre.title), 1 /* TEXT */)
                ]),
                _createElementVNode("td", _hoisted_151, [
                  _createElementVNode("span", _hoisted_152, _toDisplayString(d.livre.maison.title), 1 /* TEXT */)
                ]),
                _createElementVNode("td", _hoisted_153, [
                  _createElementVNode("div", _hoisted_154, [
                    _createElementVNode("button", {
                      class: "o-btn-edit",
                      onClick: $event => ($options.setEdit(d))
                    }, [
                      _hoisted_156,
                      _createTextVNode(" Éditer ")
                    ], 8 /* PROPS */, _hoisted_155),
                    _createElementVNode("button", {
                      class: "o-btn-trash",
                      onClick: $event => ($options.deleteAuteur(d))
                    }, [
                      _hoisted_158,
                      _createTextVNode(" Supprimer ")
                    ], 8 /* PROPS */, _hoisted_157)
                  ])
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]),
      _hoisted_159,
      _createElementVNode("div", _hoisted_160, [
        _createElementVNode("button", {
          onClick: _cache[29] || (_cache[29] = (...args) => ($options.add && $options.add(...args))),
          class: "o-btn o-table-btn"
        }, [
          _hoisted_161,
          _createTextVNode(" Nouveau ")
        ]),
        _hoisted_162
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}